module.exports = __webpack_public_path__ + "static/img/partner9.11aeb5d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/partner9.png
// module id = 4z3c
// module chunks = 0